import React from 'react'

import { Box, Paper, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { FileRow } from './components'

import helpers from 'helpers'
import useStyles from './styles'

const EvidenceCard = ({ evidence, setDownloading }) => {
  const classes = useStyles()

  const handleDownload = async (file, index) => {
    if (!file?.url) return
    try {
      setDownloading(true)
      const resp = await fetch(file.url, { credentials: 'include' })
      if (!resp.ok) throw new Error('Network error')
      const blob = await resp.blob()
      let mimeType = blob.type
      if (!mimeType) {
        mimeType = helpers.file.getMimeTypeFromExtension(file.name || '')
      }
      const fileObj = new File([blob], file.name || `file-${index}`, {
        type: mimeType,
      })
      helpers.file.handleDownload(fileObj, file.name)
    } catch {
      window.open(file.url, '_blank')
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Paper variant="outlined" className={classes.evidenceCard}>
      <Typography className={classes.evidenceTitle}>
        {evidence.title}
      </Typography>
      {evidence.description && (
        <Typography className={classes.evidenceDescription}>
          {evidence.description}
        </Typography>
      )}

      {!isEmpty(evidence.modelDocuments) && (
        <Box mt={1}>
          <Typography className={classes.evidenceSectionLabel}>
            Documentos de Referência
          </Typography>
          <Box display="flex" flexDirection="column" gridGap={4} mt={0.5}>
            {evidence.modelDocuments.map((file, i) => (
              <FileRow
                key={file.id ?? i}
                file={file}
                index={i}
                onDownload={handleDownload}
              />
            ))}
          </Box>
        </Box>
      )}

      {!isEmpty(evidence.evidences) && (
        <Box mt={1}>
          <Typography className={classes.evidenceSectionLabel}>
            Arquivos Anexados
          </Typography>
          <Box display="flex" flexDirection="column" gridGap={4} mt={0.5}>
            {evidence.evidences.map((file, i) => (
              <FileRow
                key={file.id ?? i}
                file={file}
                index={i}
                onDownload={handleDownload}
              />
            ))}
          </Box>
        </Box>
      )}
    </Paper>
  )
}

export default EvidenceCard
